import { render, staticRenderFns } from "./AnswersRow.vue?vue&type=template&id=65f5cb79&scoped=true&"
import script from "./AnswersRow.vue?vue&type=script&lang=js&"
export * from "./AnswersRow.vue?vue&type=script&lang=js&"
import style0 from "./AnswersRow.vue?vue&type=style&index=0&id=65f5cb79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f5cb79",
  null
  
)

export default component.exports